import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Typography, Tabs, Tab, Box, Chip, Button, Modal, Card, CardHeader, IconButton, CardContent, Divider, Grid, TextField, FormControl, InputLabel, Select, MenuItem, CardActions, FormLabel, RadioGroup, FormControlLabel, Radio, Checkbox, Backdrop, CircularProgress } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import { CloseOutlined, ExpandMore, ChevronRight } from '@mui/icons-material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { TreeView, TreeItem } from '@mui/x-tree-view';
import TreeView, { flattenTree } from "react-accessible-treeview";
import ReactQuill from 'react-quill'
import "react-quill/dist/quill.snow.css";
import { styled } from '@mui/material/styles';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import { formatDate } from '../../helpers/custom';
import "./styles.css";
import el from 'date-fns/esm/locale/el/index.js';
import ArrowRightTwoToneIcon from '@mui/icons-material/ArrowRightTwoTone';
import cx from "classnames";
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';

export interface RenderTree {
    id: string;
    name: string;
    children?: readonly RenderTree[];
}

interface ArrowIconProps {
  isOpen: any;
  className?: any;
}

interface CheckBoxIconsProps {
  variant: any;
  [key: string]: any; // Allow any other props
}

interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window_prop?: () => Window;
}

export interface IProps {
    fetchNotifications: any;
}

export interface IState {
    showLoader: boolean;
    children?: React.ReactNode;
    tabIndex?: number;
    tabValue: number;
    showAddAlert: any;
    title: any;
    type: any;
    start_date?: string | null;
    end_date?: string | null;
    receiverType: any;
    communityBlock: boolean;
    individualUserBlock: boolean;
    description: any;
    url: any;
    individual_users: any;
    citiesTree: any;
    selectedTreeNodes: any;
    selectedImages: any;
}
const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

const config = {
    toolbar: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'bulletedList',
        'numberedList',
        'blockQuote',
    ],
}

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

class AlertsHeader extends React.Component<RouteComponentProps & WithTranslation & IProps & Props, IState> {
    constructor(props: RouteComponentProps & WithTranslation & IProps & Props) {
        super(props);
        let current_path = this.props.location.pathname.split('/');
        let activeTab = 0;
        if (current_path[1] == 'offers') {
            activeTab = 0;
        } else if (current_path[1] == 'notifications') {
            activeTab = 1;
        } else if (current_path[1] == 'surveys') {
            activeTab = 2;
        }
        this.state = {
            showLoader: false,
            tabValue: activeTab,
            showAddAlert: false,
            title: '',
            type: '',
            start_date: formatDate(new Date(), 'Y-m-d'),
            end_date: formatDate(new Date(), 'Y-m-d'),
            receiverType: '',
            communityBlock: false,
            individualUserBlock: false,
            description: '',
            url: '',
            individual_users: '',
            citiesTree: {
                id: 'all',
                name: 'All',
                children: []
            },
            selectedTreeNodes: [],
            selectedImages: []
        }


    }
    public componentDidMount(): void {
        // axios.get(`curation-stats`).then(response => {
        //     this.setState({ curation_stats: response.data.data })
        // });
        this.getCitiesTree();
    }

    public updateContent = (newContent: any) => {
        this.setState({
            description: newContent,
        });
    }

    public onChange = (evt: any) => {
        console.log("onChange fired with event info: ", evt);
        const newContent = evt.editor.getData();
        this.setState({
            description: newContent,
        });
    }

    public onBlur = (evt: any) => {
        console.log("onBlur event called with event info: ", evt);
    };

    public afterPaste = (evt: any) => {
        console.log("afterPaste event called with event info: ", evt);
    };

    public getCitiesTree() {
        axios.get('accessibleHierarchiesCommunitiesList').then((response: any) => {
            if (response.data.success) {
                // console.log(response.data);
                let data: any[] = [];
                let citiesTree = this.state.citiesTree;
                citiesTree = {
                    id: '0',
                    name: 'All',
                    children: []
                }
                for (let i = 0; i < response.data.data.length; i++) {
                    let city = response.data.data[i];
                    let children = [];
                    for (let j = 0; j < city.community; j++) {
                        children.push({ id: city.community[j].id.toString(), name: city.community[j].name });
                    }
                    citiesTree.children.push({ id: city.id.toString(), name: city.name, children: city.community })
                }
                this.setState({ citiesTree });

            }
        });
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const data = flattenTree(this.state.citiesTree);


        /*const renderTree = (nodes: RenderTree) => (
            <TreeItem key={nodes.id} nodeId={nodes.id} label={nodes.name}>
                {Array.isArray(nodes.children)
                    ? nodes.children.map((node) => renderTree(node))
                    : null}
            </TreeItem>
        );*/

        const handleCheckBoxChange = (event: any, checked: boolean, id: any) => {
            let selectedTreeNodes = this.state.selectedTreeNodes;
            if (checked) {
                if (!selectedTreeNodes.includes(id)) {
                    selectedTreeNodes.push(id);
                }
            } else {
                if (selectedTreeNodes.includes(id)) {
                    let index = selectedTreeNodes.indexOf(id);
                    if (index !== -1) {
                        selectedTreeNodes.splice(index, 1);
                    }
                }
            }
            this.setState({ selectedTreeNodes: selectedTreeNodes });
            console.log("selectedTreeNodes", selectedTreeNodes);
        };

        const handleCityCheckBoxChange = (event: any, checked: boolean, id: any) => {
            let selectedTreeNodes = this.state.selectedTreeNodes;
            if (checked) {
                if (!selectedTreeNodes.includes(id)) {
                    selectedTreeNodes.push(id);
                    // this.state.citiesTree.map((el: any) => {
                    //     if(el.id === id){
                    //         el.children.map((ele: any) => selectedTreeNodes.push(ele.id))
                    //     }
                    // })
                }
            } else {
                if (selectedTreeNodes.includes(id)) {
                    let index = selectedTreeNodes.indexOf(id);
                    if (index !== -1) {
                        selectedTreeNodes.splice(index, 1);
                    }
                }
            }
            this.setState({ selectedTreeNodes: selectedTreeNodes });
            console.log("selectedTreeNodes", selectedTreeNodes);
        };

        
        const handleChange = (event: React.SyntheticEvent, newValue: number) => {
            if (newValue == 0) {
                this.props.history.push('/alerts')
            } else if (newValue == 1) {
                this.props.history.push('/notifications')
            } else if (newValue == 2) {
                this.props.history.push('/surveys')
            }
        };

        const handleAddAlert = () => {
            this.setState({ showLoader: true });
            let formdata = new FormData();
            formdata.append('title', this.state.title);
            formdata.append('type', this.state.type);
            formdata.append('url', this.state.url);
            console.log("communities", this.state.selectedTreeNodes);
            if (this.state.receiverType == "community") {
                // formdata.append('communities', this.state.selectedTreeNodes?.join());
                let temp: any = Array.from(this.state.selectedTreeNodes);
                temp = temp.filter((el: any) => typeof(el) === 'number');
                formdata.append('communities', temp.join(","));
            }
            if (this.state.receiverType == "individual_users") {
                formdata.append('individual_users', this.state.individual_users);
            }
            if (this.state.start_date) {
                formdata.append('start_date', this.state.start_date);
            }
            if (this.state.end_date) {
                formdata.append('expiry_date', this.state.end_date);
            }
            formdata.append('description', this.state.description);
            this.state.selectedImages.map((value: any) => {
                formdata.append('image[]', value);
            });
            // console.log("formData", formdata);

            axios.post(`addNotification`, formdata, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response: any) => {
                if (response.data.success) {
                    this.setState({ showAddAlert: false, title: '', type: '', start_date: formatDate(new Date(), 'Y-m-d'), end_date: formatDate(new Date(), 'Y-m-d'), receiverType: '', communityBlock: false, individualUserBlock: false, description: '', url: '', individual_users: '', selectedTreeNodes: [], selectedImages: [], showLoader: false });
                    toast.success(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    this.props.fetchNotifications();
                } else {
                    this.setState({ showAddAlert: false, title: '', type: '', start_date: formatDate(new Date(), 'Y-m-d'), end_date: formatDate(new Date(), 'Y-m-d'), receiverType: '', communityBlock: false, individualUserBlock: false, description: '', url: '', individual_users: '', selectedTreeNodes: [], selectedImages: [], showLoader: false });
                    toast.error(response.data.msg, {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored"
                    });
                    let errors = response.data.errors;
                    for (var error in errors) {
                        toast.error(errors[error][0], {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored"
                        });
                    }
                }
            }).catch((error) => {
                this.setState({ showAddAlert: false, title: '', type: '', start_date: formatDate(new Date(), 'Y-m-d'), end_date: formatDate(new Date(), 'Y-m-d'), receiverType: '', communityBlock: false, individualUserBlock: false, description: '', url: '', individual_users: '', selectedTreeNodes: [], selectedImages: [], showLoader: false });
                console.log(error);
                toast.error(error.response.data.msg, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored"
                });
            });
        }

        const ArrowIcon : React.FC<ArrowIconProps> = ({ isOpen, className }) => {
            const baseClass = "arrow";
            const classes = cx(
              baseClass,
              { [`${baseClass}--closed`]: !isOpen },
              { [`${baseClass}--open`]: isOpen },
              className
            );
            return <ArrowRightTwoToneIcon className={classes} />;
          };

          const CheckBoxIcons: React.FC<CheckBoxIconsProps> = ({ variant, ...rest }) => {
            switch (variant) {
              case "all":
                return <CheckBoxIcon {...rest} />;
              case "none":
                return <CheckBoxOutlineBlankIcon {...rest} />;
              case "some":
                return <IndeterminateCheckBoxIcon {...rest} />;
              default:
                return null;
            }
          };

        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={true}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <Typography variant="h4" className='page-title'>
                    {t("Alerts")}
                    <Button size="small" variant='contained' className='link float-right' sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddAlert: true })}>Add</Button>
                </Typography>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={this.state.tabValue} onChange={handleChange} aria-label="basic tabs example">
                        <Tab label="Offers" />
                        <Tab label="Notifications" />
                        <Tab label="Surveys" />
                    </Tabs>
                </Box>

                <Modal
                    open={this.state.showAddAlert}
                    onClose={() => this.setState({ showAddAlert: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{ 'overflowY': 'scroll' }}
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title="Add Alert"
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showAddAlert: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={8} xs={12}>
                                        <Grid container spacing={2}>
                                            <Grid item md={12} xs={12}>
                                                <FormControl>
                                                    {/* <FormLabel id="demo-row-radio-buttons-group-label">Type:</FormLabel> */}
                                                    <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="row-radio-buttons-group"
                                                        value={this.state.receiverType}
                                                        onChange={(e: any) => {
                                                            this.setState({ receiverType: e.target.value })
                                                            if (e.target.value == 'community') {
                                                                this.setState({ communityBlock: true, individualUserBlock: false });
                                                            } else if (e.target.value == 'individual_users') {
                                                                this.setState({ individualUserBlock: true, communityBlock: false });
                                                            }
                                                            console.log(this.state.receiverType);
                                                        }}
                                                    >
                                                        <FormControlLabel value="community" control={<Radio />} label="Community" />
                                                        <FormControlLabel value="individual_users" control={<Radio />} label="Individual Users" />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Grid>
                                            <Grid item md={12} xs={12}>
                                                <FormControl fullWidth={true}>
                                                    <TextField
                                                        id="route-name-input"
                                                        label="Title"
                                                        value={this.state.title}
                                                        onChange={(e: any) => this.setState({ title: e.target.value })}
                                                        fullWidth={true}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item md={4} xs={12}>
                                                <FormControl fullWidth={true}>
                                                    <InputLabel id="city-label">Type</InputLabel>
                                                    <Select
                                                        labelId="city-label"
                                                        value={this.state.type}
                                                        onChange={(e) => this.setState({ type: e.target.value })}
                                                        displayEmpty
                                                        label="Type"
                                                        fullWidth={true}
                                                    >
                                                        <MenuItem key={1} value="promo">Offers</MenuItem>
                                                        <MenuItem key={2} value="nonpromo">Notifications</MenuItem>
                                                        <MenuItem key={3} value="survey">Surveys</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item md={4} xs={12}>
                                                <FormControl fullWidth={true}>
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DatePicker
                                                            inputFormat="yyyy-MM-dd"
                                                            mask="____-__-__"
                                                            views={['year', 'month', 'day']}
                                                            renderInput={(props) => <TextField {...props} />}
                                                            label="Start Date"
                                                            value={this.state.start_date}
                                                            onChange={(newValue: any) => {
                                                                // console.log(formatDate(newValue, 'Y-m-d'));
                                                                this.setState({ start_date: formatDate(newValue, 'Y-m-d') });
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>
                                            <Grid item md={4} xs={12}>
                                                <FormControl fullWidth={true}>
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DatePicker
                                                            inputFormat="yyyy-MM-dd"
                                                            mask="____-__-__"
                                                            views={['year', 'month', 'day']}
                                                            renderInput={(props) => <TextField {...props} />}
                                                            label="End Date"
                                                            value={this.state.end_date}
                                                            onChange={(newValue: any) => {
                                                                this.setState({ end_date: formatDate(newValue, 'Y-m-d') });
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </FormControl>
                                            </Grid>
                                            {
                                                this.state.type == 'survey' && <Grid item md={12} xs={12}>
                                                    <TextField
                                                        id="route-name-input"
                                                        label="URL"
                                                        value={this.state.url}
                                                        onChange={(e: any) => this.setState({ url: e.target.value })}
                                                        fullWidth={true}
                                                    />
                                                </Grid>
                                            }
                                            <Grid item md={12} xs={12}>
                                                <ReactQuill
                                                    theme="snow"
                                                    value={this.state.description}
                                                    onChange={(description: any) => {
                                                        this.setState({ description })
                                                    }}
                                                    modules={
                                                        {
                                                            toolbar: [
                                                                [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                                                                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                                                [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                                                                ['link', 'image', 'video', 'table']
                                                            ]
                                                        }
                                                    }
                                                    formats={
                                                        [
                                                            'header', 'font', 'size',
                                                            'bold', 'italic', 'underline', 'strike', 'blockquote',
                                                            'list', 'bullet', 'indent',
                                                            'link', 'image', 'video', 'table'
                                                        ]
                                                    }
                                                />
                                            </Grid>
                                            <Grid item md={4} xs={12}>
                                                <Button
                                                    component="label"
                                                    role={undefined}
                                                    variant="contained"
                                                    tabIndex={-1}
                                                    startIcon={<CloudUploadIcon />}
                                                >
                                                    Upload file
                                                    <VisuallyHiddenInput
                                                        type="file"
                                                        accept=".jpeg,.png,.jpg"
                                                        multiple
                                                        onChange={(e) => {
                                                            console.log(e.target.files)
                                                            if (e.target.files?.length) {
                                                                let selectedImages = this.state.selectedImages;
                                                                selectedImages = [];
                                                                for (let i = 0; i < e.target.files.length; i++) {
                                                                    selectedImages.push(e.target.files[i]);
                                                                }
                                                                this.setState({ selectedImages })
                                                            }
                                                        }
                                                        }
                                                    />
                                                </Button>
                                            </Grid>
                                            <Grid item md={8} xs={12}>
                                                {
                                                    this.state.selectedImages.map((selectedImage: any, key: number) => {
                                                        return <Chip key={key} label={selectedImage.name} />
                                                    })
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        {
                                            this.state.communityBlock && <Grid item md={12} xs={12}>
                                                <Box sx={{ minHeight: 110, flexGrow: 1, maxWidth: 300, height: "400px", overflowY: 'scroll' }} className="checkbox">
                                                    <TreeView
                                                        data={data}
                                                        aria-label="Checkbox tree"
                                                        multiSelect
                                                        selectedIds={[...this.state.selectedTreeNodes]}
                                                        defaultExpandedIds={[1]}
                                                        propagateSelect
                                                        propagateSelectUpwards
                                                        togglableSelect
                                                        // onSelect={(props) => console.log('onSelect callback: ', props)}
                                                        onNodeSelect={(props) => {
                                                            this.setState({selectedTreeNodes: props.treeState?.selectedIds})
                                                            console.log("props", this.state.selectedTreeNodes);
                                                        }}
                                                        nodeRenderer={({
                                                            element,
                                                            isBranch,
                                                            isExpanded,
                                                            isSelected,
                                                            isHalfSelected,
                                                            isDisabled,
                                                            getNodeProps,
                                                            level,
                                                            handleSelect,
                                                            handleExpand,
                                                        }) => {
                                                            return (
                                                            <Grid container spacing={2}
                                                                {...getNodeProps({ onClick: handleExpand })}
                                                                style={{
                                                                marginLeft: 40 * (level - 1),
                                                                opacity: isDisabled ? 0.5 : 1,
                                                                }}
                                                            >
                                                                {isBranch && <ArrowIcon isOpen={isExpanded} />}
                                                                <CheckBoxIcons
                                                                    className="checkbox-icon"
                                                                    onClick={(e: any) => {
                                                                        handleSelect(e);
                                                                        e.stopPropagation();
                                                                    }}
                                                                    variant={
                                                                        isHalfSelected ? "some" : isSelected ? "all" : "none"
                                                                    }
                                                                />
                                                                <span>{element.name}</span>
                                                            </Grid>
                                                            );
                                                        }}
                                                        />
                                                </Box>
                                            </Grid>
                                        }
                                        {
                                            this.state.individualUserBlock && <Grid item md={12} xs={12}>
                                                <TextField
                                                    id="route-name-input"
                                                    label="Individual Users"
                                                    multiline
                                                    rows={4}
                                                    value={this.state.individual_users}
                                                    onChange={(e: any) => this.setState({ individual_users: e.target.value })}
                                                    fullWidth={true}
                                                />
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>

                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showAddAlert: false })}>Close</Button>
                                <Button
                                    size='small'
                                    variant='contained'
                                    sx={{ outline: 'none !important' }}
                                    disabled={(this.state.selectedTreeNodes.length == 0 && !this.state.individual_users) || !this.state.title || !this.state.type || !this.state.start_date || !this.state.end_date}
                                    onClick={() => handleAddAlert()}
                                >
                                    Add Alert
                                </Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
            </div>
        )
    }
}

export default withRouter(withTranslation()(AlertsHeader))